import React, { Component } from 'react';
import PhoneInput from 'react-phone-input-2'

import CustomMultiSelect from '../commons/helpers/customMultiSelect'; 

import{ MSG_REQUIRED} from '../../configs/msgConfigs';
import {PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../configs/staticConfigs';
import { LBL_CLIENT_CATEGORY,LBL_SEL_CLIENT_CATEGORY, LBL_SEND_VERIFI_EMAIL,LBL_DEPARTMENTS, LBL_CLIENT_PROFILE, LBL_ADD_NEW_CLIENT } from '../../configs/labelConfigs';
import CustomTitle from '../commons/helpers/customTitle';


class QuickAdd extends Component {
    
    render(){

        const { formErrors,quickData ,id} = this.props; 

        
        return(
            <React.Fragment>
                {id==="client-quick-add" && <CustomTitle title={LBL_ADD_NEW_CLIENT} className="mb-2" />}
                {id==="client-quick-add"?<div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.companyName}</label>
                            <div className="text-input"><input type="text" value={quickData.companyName||""} placeholder={LBL_CLIENT_PROFILE.companyName} name="companyName" onChange={this.props.onHandleChange} className={formErrors.companyName.length >0 ? "input-error" : ''}/></div>
                            {formErrors.companyName.length >0 && formErrors.companyName!==MSG_REQUIRED && (
                                <div className="text-red left-align text-12">{formErrors.companyName}</div>
                            )} 
                        </div>
                    </div>
                </div>:<div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.companyName}</label>
                            <div className="text-input"><input type="text" placeholder={LBL_CLIENT_PROFILE.companyName} name="companyName" onChange={this.props.onHandleChange} className={formErrors.companyName.length >0 ? "input-error" : ''}/></div>
                            {formErrors.companyName.length >0 && formErrors.companyName!==MSG_REQUIRED && (
                                <div className="text-red left-align text-12">{formErrors.companyName}</div>
                            )} 
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.website}</label>
                            <div className="input weburl-input"><input type="url" placeholder={LBL_CLIENT_PROFILE.website} name="websiteUrl" onChange={this.props.onHandleChange}  autoComplete="off" /></div>
                            {/* className={formErrors.websiteUrl.length >0 ? "input-error" : ''} */}
                        </div>
                    </div>
                </div>}
                {id==="client-quick-add" ? <CustomTitle title={LBL_CLIENT_PROFILE.primaryContact} className="my-2 " />:
                <h6>{LBL_CLIENT_PROFILE.primaryContact}</h6>}
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.firstName}</label>
                            <div className="text-input">
                                <input type="text" value={quickData.firstName||""} placeholder={LBL_CLIENT_PROFILE.firstName} name="firstName" onChange={this.props.onHandleChange} className={formErrors.firstName.length >0 ? "input-error" : ''} />
                                </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.lastName}</label>
                            <div className="text-input">
                                <input type="text" value={quickData.lastName||""} placeholder={LBL_CLIENT_PROFILE.lastName} name="lastName" onChange={this.props.onHandleChange} className={formErrors.lastName.length >0 ? "input-error" : ''} />
                                </div>
                        </div>
                    </div>
                </div> 
                <div className="row">
                    <div className={id==="client-quick-add" ?"col-md-12":"col-md-6"}>
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.emailAddress}</label>
                            <div className="input email-input">
                                <input type="email" value={quickData.emailAddress||""} placeholder={LBL_CLIENT_PROFILE.emailAddress} name="emailAddress" onChange={this.props.onHandleChange} className={formErrors.emailAddress.length >0 ? "input-error" : ''} />
                                </div>
                            {formErrors.emailAddress.length >0 && formErrors.emailAddress!==MSG_REQUIRED && (
                                <div className="text-red left-align text-12">{formErrors.emailAddress}</div>
                            )} 
                        </div>
                    </div>
                    <div className={id==="client-quick-add" ?"col-md-12":"col-md-6"}>
                        <div className="form-group">
                            <label>{LBL_CLIENT_PROFILE.mobileNumber}</label>
                            <div className={formErrors.contactNumber.length>0?'input-error':''}>
                                <PhoneInput 
                                  country={PHONE_ISD_CODE}
                                  inputProps={{
                                    name: 'contactNumber',
                                  }}
                                  onChange={this.props.onPhoneInputChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={id==="client-quick-add" ?"col-md-12":"col-md-6"}>
                        <div className="form-group">
                                <label>{LBL_CLIENT_PROFILE.position}</label>
                                <div className="text-input"><input type="text" value={quickData.position||""} placeholder={LBL_CLIENT_PROFILE.position} name="position" onChange={this.props.onHandleChange}/></div>
                            </div>
                    </div>
                    <div className={id==="client-quick-add" ?"col-md-12":"col-md-6"}>
                        <div className="form-group">
                            <label>{LBL_CLIENT_CATEGORY}</label>
                            <div className="form-group select-input">
                                <select name="category" onChange={this.props.onHandleChange} className={formErrors.category.length>0?'input-error':''}  >
                                    <option key="0" value="0">{LBL_SEL_CLIENT_CATEGORY}</option>
                                            {Array.isArray(this.props.clientCategoryBasicData) && this.props.clientCategoryBasicData.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)} 
                                </select>  </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    
                    {this.props.deptMultiSelList && this.props.deptMultiSelList.length>0 && <div className={id==="client-quick-add" ?"col-md-12":"col-md-6"}>
                        <div className="form-group">
                            <label>{LBL_DEPARTMENTS}</label>
                            <div className="form-group multisel_textbox">
                                    <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={this.props.deptMultiSelList} trimString='yes'  onChange={selected =>this.props.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"9" }} tabIndex="9" classValue={formErrors?.departments && formErrors.departments.length > 0 ? "input-error" : ''} needSelectAll="yes" />
                                    </div>
                            </div> 
                        </div>
                    </div>}

                    <div className="col-md-6">
                        <div className="form-group padding-top-15">
                            <div className="custom-checkbox">
                                <input type="checkbox" id="sendEmailVerification" name="sendEmailVerification"  onChange={this.props.onHandleChange} checked={this.props.sendEmail} value={this.props.sendEmail} />
                                <label className="checkbox" htmlFor="sendEmailVerification"></label>
                                <label className="labeltext" htmlFor="sendEmailVerification">{LBL_SEND_VERIFI_EMAIL}</label>
                            </div>  
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}
export default QuickAdd;